<template>
    <div class="m15 break page_logo" ref="container" id="incentivo" v-if="contribuicao">
        <div class="site"></div>
        <h4 class="simulator-title loaded">Incentivo Fiscal</h4>
        <saudacao :cliente.sync="cliente.pessoa" ref="saudacao" class="saudacao"/>

        <p>
            A Previdência Privada além de ser um investimento é também uma ferramenta tributária para aquelas pessoas que desejam diminuir o valor pago no Imposto de Renda de Pessoa Física.
        </p>
        <p>
            No futuro, o valor do seu benefício de aposentadoria não será suficiente para manter o seu
            padrão de vida, por esse motivo, afim de estimular os brasileiros na formação de reserva no
            longo prazo, o governo estabelece que é possível deduzir até 12% da sua renda bruta
            tributável nas contribuições para a Previdência Privada no modo PGBL.
        </p>
        <p>
            É importante lembrar que a Previdência Privada é o único investimento que permite a dedução
        na Declaração de Imposto de Renda. Além de diversificar seus investimentos entre aqueles
        que possuem maior liquidez e são destinados para as situações de emergência, a Previdência
        Privada deve compor seu portfólio de investimentos de longo prazo, pois assim você
        aproveitará ao máximo o benefício fiscal disponível.
        </p>
        <p>
            Abaixo apresentamos a simulação do impacto tributário que as contribuições para a Previdência podem gerar na sua declaração de Imposto de Renda:
        </p>


        <div class="flex-row print-row">
            <div class="col-xs-12 col-sm-6 print-col-6">
                <table class="print-table print-table-striped striped bordered">
                    <thead>
                        <tr>
                            <th colspan="2" style="text-align:center;">{{ contribuicao.tipo == 'P' ? 'CENÁRIO ATUAL' : 'DECLARAÇÃO SIMPLIFICADO'}}</th>
                        </tr>
                    </thead>
                    <tbody >
                        <tr class="is-bold print-bold">
                            <td>RENDIMENTO TRIBUTÁVEL TOTAL</td>
                            <td>{{ contribuicao.rendimento_tributavel_total | dinheiro }}</td>
                        </tr>
                        <template v-if="contribuicao.tipo == 'P'">
                            <tr>
                                <td>PREVIDÊNCIA OFICIAL</td>
                                <td>{{ contribuicao.previdencia_oficial | dinheiro }}</td>
                            </tr>
                            <tr>
                                <td>PREVIDÊNCIA PRIVADA</td>
                                <td>{{ contribuicao.previdencia_privada | dinheiro }}</td>
                            </tr>
                        </template>
                        <template v-else>
                            <tr>
                                <td>DESCONTO SIMPLIFICADO</td>
                                <td>{{ contribuicao.desconto_simplificado_vgbl | dinheiro }}</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                            </tr>
                            <tr>

                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                            </tr>
                        </template>


                        <template v-if="contribuicao.tipo === 'P'">

                            <tr>
                                <td>DEPENDENTES</td>
                                <td>{{ contribuicao.dependentes | dinheiro }}</td>
                            </tr>

                            <tr>
                                <td>DESPESAS COM INSTRUÇÃO</td>
                                <td>{{ contribuicao.despesa_instrucao | dinheiro }}</td>
                            </tr>

                            <tr>
                                <td>DESPESAS MÉDICAS</td>
                                <td>{{ contribuicao.despesa_medica | dinheiro }}</td>
                            </tr>

                            <tr>
                                <td>PENSÃO ALIMENTÍCIA</td>
                                <td>{{ contribuicao.pensao_alimenticia | dinheiro }}</td>
                            </tr>

                            <tr>
                                <td>LIVRO CAIXA</td>
                                <td>{{ contribuicao.livro_caixa | dinheiro }}</td>
                            </tr>

                            <tr class="is-bold print-bold">
                                <td>TOTAL DE DESPESAS</td>
                                <td>{{ contribuicao.total_despesas | dinheiro }}</td>
                            </tr>
                        </template>
                        <tr>
                            <td colspan="2">&nbsp;</td>
                        </tr>
                        <tr class="is-bold print-bold">
                            <td>BASE DE CÁLCULO</td>
                            <td>{{ Math.max(0, contribuicao.base_calculo) | dinheiro }} </td>
                        </tr>

                        <tr >
                            <td>ALÍQUOTA IR</td>
                            <td>{{ contribuicao.irpf_aliquota }}%</td>
                        </tr>

                        <tr >
                            <td>IR DEVIDO II</td>
                            <td>{{ contribuicao.irpf_devido_2 | dinheiro }}</td>
                        </tr>


                        <tr >
                            <td>PARCELA A DEDUZIR</td>
                            <td>{{ contribuicao.irpf_parcela_deduzir | dinheiro }}</td>
                        </tr>

                        <tr>
                            <td>DOAÇÕES</td>
                            <td>{{ contribuicao.doacoes | dinheiro }}</td>
                        </tr>

                        <tr v-if="contribuicao.ano <= 2019">
                            <td>INSS DOMÉSTICA</td>
                            <td>{{ contribuicao.inss_domestica | dinheiro }}</td>
                        </tr>

                        <tr>
                            <td>IR DEVIDO</td>
                            <td>{{ Math.abs(contribuicao.irpf_devido) | dinheiro }}</td>
                        </tr>


                        <tr class="print-bold">
                            <td>IMPOSTO RETIDO NA FONTE</td>
                            <td>{{ contribuicao.imposto_retido_fonte | dinheiro }}</td>
                        </tr>

                        <tr class="is-bold print-bold print-text-primary">
                            <td class="green-text">SALDO
                                <template v-if="exibir_restituicao">{{ contribuicao.saldo_imposto > 0 ? 'A PAGAR' : 'A RESTITUIR' }}</template>
                            </td>
                            <td>
                                {{ Math.abs(contribuicao.saldo_imposto) | dinheiro }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-xs-12 col-sm-6 print-col-6">
                <table class="print-table print-table-striped striped bordered">
                    <thead>
                        <tr>
                            <th colspan="2" style="text-align:center;">{{ contribuicao.tipo == 'P' ? 'CENÁRIO IDEAL' : 'DECLARAÇÃO COMPLETO' }}</th>
                        </tr>
                    </thead>
                    <tbody v-if="contribuicao">
                        <tr class="is-bold print-bold">
                            <td>RENDIMENTO TRIBUTÁVEL TOTAL</td>
                            <td>{{ contribuicao.rendimento_tributavel_total | dinheiro }}</td>
                        </tr>
                        <tr>
                            <td>PREVIDÊNCIA OFICIAL</td>
                            <td>
                                <template v-if="contribuicao.tipo === 'P'">
                                    {{ contribuicao.previdencia_oficial | dinheiro }}
                                </template>
                                <template v-else>
                                    {{ contribuicao.previdencia_oficial_vgbl | dinheiro  }}
                                </template>
                            </td>
                        </tr>
                        <tr>
                            <td>PREVIDÊNCIA PRIVADA</td>
                            <td>{{ contribuicao.previdencia_privada_ideal | dinheiro }}</td>
                        </tr>

                        <template v-if="contribuicao.tipo === 'P'">
                            <tr>
                                <td>DEPENDENTES</td>
                                <td>{{ contribuicao.dependentes | dinheiro }}</td>
                            </tr>

                            <tr>
                                <td>DESPESAS COM INSTRUÇÃO</td>
                                <td>{{ contribuicao.despesa_instrucao | dinheiro }}</td>
                            </tr>

                            <tr>
                                <td>DESPESAS MÉDICAS</td>
                                <td>{{ contribuicao.despesa_medica | dinheiro }}</td>
                            </tr>

                            <tr>
                                <td>PENSÃO ALIMENTÍCIA</td>
                                <td>{{ contribuicao.pensao_alimenticia | dinheiro }}</td>
                            </tr>

                            <tr>
                                <td>LIVRO CAIXA</td>
                                <td>{{ contribuicao.livro_caixa | dinheiro }}</td>
                            </tr>
                            <tr class="is-bold print-bold">
                                <td>TOTAL DE DESPESAS</td>
                                <td>{{ contribuicao.total_despesas_ideal | dinheiro }}</td>
                            </tr>
                        </template>
                         <template v-else>
                            <tr>
                                <td>TOTAL DE DESPESAS</td>
                                <td>{{ contribuicao.total_despesas_ideal | dinheiro }}</td>
                            </tr>
                        </template>

                        <tr>
                            <td colspan="2">&nbsp;</td>
                        </tr>
                        <tr class="print-bold">
                            <td>BASE DE CÁLCULO</td>
                            <td>{{ Math.max(0, contribuicao.base_calculo_ideal) | dinheiro }} </td>
                        </tr>

                        <tr >
                            <td>ALÍQUOTA IR</td>
                            <td>
                                <template v-if="contribuicao.irpf_devido_ideal">
                                    {{ contribuicao.irpf_devido_ideal.irpf.aliquota }}%
                                </template>
                            </td>
                        </tr>

                        <tr >
                            <td>IR DEVIDO II</td>
                            <td>
                                <template v-if="contribuicao.irpf_devido_ideal">
                                    {{ contribuicao.irpf_devido_ideal.ii | dinheiro }}
                                </template>
                            </td>
                        </tr>


                        <tr >
                            <td>PARCELA A DEDUZIR</td>
                            <td>
                                <template v-if="contribuicao.irpf_devido_ideal">
                                {{ contribuicao.irpf_devido_ideal.irpf.valor_parcela_deducao | dinheiro  }}
                                </template>
                            </td>
                        </tr>

                        <tr>
                            <td>DOAÇÕES</td>
                            <td>{{ contribuicao.doacoes | dinheiro }}</td>
                        </tr>

                        <tr v-if="contribuicao.ano <= 2019">
                            <td>INSS DOMÉSTICA</td>
                            <td>{{ contribuicao.inss_domestica | dinheiro }}</td>
                        </tr>

                        <tr>
                            <td>IR DEVIDO</td>
                            <td>
                                <template v-if="contribuicao.irpf_devido_ideal">
                                    {{ Math.abs(contribuicao.irpf_devido_ideal.i) | dinheiro }}
                                </template>
                            </td>
                        </tr>

                        <tr class="print-bold">
                            <td>IMPOSTO RETIDO NA FONTE</td>
                            <td>{{ contribuicao.imposto_retido_fonte | dinheiro }}</td>
                        </tr>

                        <tr class="is-bold print-bold">
                            <td>SALDO
                                <template v-if="exibir_restituicao">
                                    {{ contribuicao.irpf_devido_ideal.saldo_imposto > 0 ? 'A PAGAR' : 'A RESTITUIR'}}
                                </template>
                            </td>
                            <td>
                                <template v-if="contribuicao.irpf_devido_ideal">
                                    {{ Math.abs(contribuicao.irpf_devido_ideal.saldo_imposto) | dinheiro }}
                                </template>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <template v-if="contribuicao.tipo === 'P'">

            <p v-if="contribuicao.irpf_devido_ideal">
                <template v-if=" contribuicao.irpf_devido_ideal.irpf.aliquota === 0">
                    No caso desta declaração, mesmo com a contribuição para a Previdência Privada, não haveria mudança, uma vez que não há saldo de imposto devido.
                    Vale lembrar que a Previdência Privada é um tipo de investimento com projeção de retorno, diferentemente das outras despesas pessoais e profissionais.
                    Você pode optar pela contribuição mensal para o modo VGBL, que não possui benefício fiscal, mas em contrapartida a tributação incide no momento do resgate ou recebimento de renda, apenas sobre a rentabilidade do plano.
                    Como não têm obrigatoriedade de participação em inventário, os investimentos em planos de previdência podem ser utilizados no planejamento da sucessão familiar.
                </template>
                <template v-else-if="porcentagem_previdencia">
                    Na tabela, temos um espelho da sua declaração de Imposto de Renda, e o valor do Imposto devido no ano.
                    Observamos que você já contribui com aproximadamente 12% ou 12% da sua renda tributável para o PGBL, aproveitamento integralmente do benefício fiscal, o que resultou na diminuição significativa da carga tributária.
                    Se não houvesse nenhuma contribuição à previdência privada ocorreria um aumento de {{ Math.abs(porcentagem_imposto).toFixed(2) }}% do imposto devido, que sairia dos atuais {{ contribuicao.previdencia_privada_ideal | dinheiro }} para {{ Math.abs(contribuicao.previdencia_privada_ideal -  diminuicao) | dinheiro }}, uma diferença de {{ Math.abs(diminuicao) | dinheiro }}.
                </template>
                <template v-else>
                    Na tabela, temos um espelho da sua declaração de Imposto de Renda, e o valor do Imposto devido no ano.
                    Caso você realize a contribuição de 12% da sua renda tributável para o PGBL, que seria de {{ contribuicao.rendimento_tributavel_total * 0.12 | dinheiro  }},
                    você teria uma diminuição de {{ Math.abs(diminuicao) | dinheiro }} do imposto devido, ou seja, {{ Math.abs(porcentagem_imposto).toFixed(2) }}% a menos.
                </template>
            </p>
        </template>

        <template v-else>

            <p v-if="contribuicao.irpf_devido_ideal.saldo_imposto < contribuicao.saldo_imposto">
                Para a sua declaração que é enviada no modelo simplificado, realizamos o cálculo destinando
                12% da sua renda tributável para a Previdência Privada, e incluímos também o valor de INSS de
                acordo com sua renda.<br />
                De acordo com a tabela acima, caso você realize as contribuições para o PGBL, você terá um
                imposto devido de <b>{{ contribuicao.saldo_imposto | dinheiro }}</b>, que é <b>{{ Math.abs(diminuicao) | dinheiro }}</b> a menos do que o imposto devido atual.<br />
                Ou seja, você terá um diminuição de 23% da carga tributária.
            </p>
            <p v-else>
                    Para a sua declaração que é enviada no modelo simplificado, realizamos o cálculo destinando
                    12% da sua renda tributável para a Previdência Privada, e incluímos também o valor de INSS de
                    acordo com sua renda.<br>
                    De acordo com a tabela acima, mesmo que você contribua com a totalidade para a Previdência
                    Privada, o valor do imposto devido é maior que o atual. Isso porque o seu perfil se enquadra
                    corretamente para a declaração no modelo simplificado.<br />
                    Neste cenário é interessante realizar contribuições para o VGBL, isso porque você não precisa
                    do incentivo fiscal no cenário atual, e no futuro a tributação sobre o resgate será menor.
            </p>
        </template>
        <p>
            É extremamente interessante utilizar a Previdência Privada como ferramenta para diminuição
            da carga tributária, pois, já existe o retorno real do valor aplicado da declaração de Imposto de
            Renda, como diminuição do saldo de imposto, e além disso é um investimento como os
            demais, com rentabilização dos recursos ao longo do ano. Mas atenção, deve-se ter em mente
            que estamos falando de um investimento de LONGO PRAZO. Caso você resgate o valor no
            curto prazo, o benefício fiscal não acontecerá.
        </p>
    </div>
</template>

<style lang="scss" scoped>
    @import "../relatorios/Simulador.scss";

    .is-bold{
        font-weight: bold;
    }
</style>


<script>

import Saudacao from './Saudacao'

export default {

    props: {
        cliente: Object,
    },

    components: {
        Saudacao
    },

     methods: {

        plot()
        {
            if (this.$refs.container && this.contribuicao)
            {
                return this.$refs.container.outerHTML;
            } else {
                return ''
            }

        },
    },


    computed: {

        contribuicao() {
            return this.cliente.contribuicao_previdencia_privada;
        },
        porcentagem_imposto() {

            return (this.diminuicao / this.contribuicao.irpf_devido) * 100;
        },

        diminuicao()
        {
            return this.contribuicao.saldo_imposto - this.contribuicao.irpf_devido_ideal.saldo_imposto;
        },


        porcentagem_previdencia() {

            return this.contribuicao.previdencia_privada >= (this.contribuicao.rendimento_tributavel_total * 0.10)
        },


        exibir_restituicao() {

            const valor = this.contribuicao.tipo === 'P' ? this.contribuicao.previdencia_privada :  this.contribuicao.previdencia_privada_ideal;

            return valor <= (this.contribuicao.rendimento_tributavel_total  * 0.10)
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/graficos-simulador/IncentivoFiscal.vue